import React, { useEffect, useState } from 'react';
import './TextMessageModal.css';
import { base_url } from '../secrets/env';
import failedIcon from '../assets/images/failed_icon.png'
import successIcon from '../assets/images/success_icon.png'
import useDetectKeyboardOpen from 'use-detect-keyboard-open';
import { PulseLoader } from 'react-spinners';

const TextMessageModal = ({ onClose }) => {
  const [message, setMessage] = useState('');
  const [status, setStatus] = useState('compose'); // 'compose' | 'sent'
  const [sending, setSending] = useState(false);
  let [loading, setLoading] = useState(false);
  const color ='#080E57'

  const handleSend = async () => {
    setSending(true);
    setLoading(true)
    setStatus('sending')
    try {
      // Simulate email sending API
    //   await new Promise(res => setTimeout(res, 2000));
    const response = await fetch(`${base_url}/api/v1/send-text-note`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ message }), // this sends the text body
    });
    if (response.ok) {
        setStatus("sent");
        console.log('inside this')
        const audio = new Audio('audios/success.wav');
        audio.play();
      } else {
        // throw new Error("Failed to send email.");
        setStatus('failed');
        const audio = new Audio('audios/error.mp3');
        audio.play();
      }
    } catch (err) {
        setStatus('failed');
        setLoading(false)
        const audio = new Audio('audios/error.mp3');
        audio.play();
      } finally {
      // setStatus('sending');
      setSending(false);
      setLoading(false)
    }
  };

  const reset = () => {
    setMessage('');
    setStatus('compose');
  };
  const isKeyboardOpen = useDetectKeyboardOpen();
  // console.log(isKeyboardOpen)
  let userAgent  = window.navigator.userAgent
  // console.log(/iphone|ipad|ipod/i.test(userAgent))
  let isIoS = /iphone|ipad|ipod/i.test(userAgent)
  console.log(status)
  return (
    // <div className="modal-overlay"
    <div className={`modal-overlay ${(isKeyboardOpen && !isIoS) ? 'keyboard-open' : ''}`}
    //  onClick={onClose}
    onClick={(e) => {
      if (!loading) {
        onClose(e);
      }
    }}
  
    >
        <div className="modal">
        {status === 'compose' ? (
            <>
                <h2>Send a Text Message</h2>
                <textarea
                    className='text-area'
                    placeholder="Type your message here..."
                    value={message}
                    onChange={e => setMessage(e.target.value)}
                />
                <div className="modal-buttons">
                    <button className="cancel" onClick={onClose}>Cancel</button>
                    <button
                    // className="send"
                        className={`send-button ${(!message.trim() || sending) ? "disabled" : "active"}`}
                        disabled={!message.trim() || sending}
                        onClick={handleSend}
                    >
                    Send
                    </button>
                </div>
            </>
        // ) : status === 'sending' ? (
        ) : loading ? (
          <>
            <h2>Please wait, sending Text Message</h2>
            <div className="sweet-loading">
              <PulseLoader
                color={color}
                loading={loading}
                // cssOverride={override}
                size={30}
                aria-label="Loading Spinner"
                data-testid="loader"
              />
            </div>
            <div className="modal-buttons">
              <button className={`cancel1 ${(!message.trim() || loading) ? "disabled" : "active"}`} >Cancel</button>
              {/* <button className={`cancel1 "disabled" }`} >Cancel</button> */}
              <button
              // className="send"
                  className={`send-button ${(!message.trim() || loading) ? "disabled" : "active"}`}
                  disabled={!message.trim() || loading}
                  onClick={handleSend}
              >
              Send
              </button>
            </div>
          </>
        ) : status === 'sent' ? (
            <>
              <h2>Message Sent Successfully</h2>
              {/* <img  src="/images/success_icon.png" alt="Success" /> */}
              <div className="failed-icon">
                <img  src={successIcon} alt="Success" />
              </div>
              <div className="modal-buttons1">
                <button className="cancel large-width" onClick={onClose}>Cancel</button>
                <button className="write-again" onClick={reset}>Write Again</button>
              </div>
            </>
          ) : (
            <>
              <h2>Failed To Send Message</h2>
              {/* <img src="/images/failed_icon.png" alt="Failed" /> */}
              <div className="success-icon">
                <img src={failedIcon} alt="Failed" />
              </div>
              <div className="modal-buttons1">
                <button className="cancel large-width" onClick={onClose}>Cancel</button>
                <button className="write-again" onClick={reset}>Write Again</button>
              </div>
            </>
          )}
        </div>
    </div>
  );
};

export default TextMessageModal;
